export const CREATE_REVIEW_SUCCESS = 'CREATE_REVIEW_SUCCESS';
export const CREATE_REVIEW_FAILURE = 'CREATE_REVIEW_FAILURE';
export const GET_ALL_REVIEWS_SUCCESS = 'GET_ALL_REVIEWS_SUCCESS';
export const GET_ALL_REVIEWS_FAILURE = 'GET_ALL_REVIEWS_FAILURE';

export const CREATE_RATING_SUCCESS = 'CREATE_RATING_SUCCESS';
export const CREATE_RATING_FAILURE = 'CREATE_RATING_FAILURE';
export const GET_ALL_RATINGS_SUCCESS = 'GET_ALL_RATINGS_SUCCESS';
export const GET_ALL_RATINGS_FAILURE = 'GET_ALL_RATINGS_FAILURE';